import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'companyProductUserMemberRoleToIconPipe' })
export class CompanyProductUserMemberRoleToIconPipe implements PipeTransform {
  transform(dc: string | null | undefined): string {
    switch (dc) {
      case 'assistant-manager':
      case 'cco':
      case 'ceo':
      case 'cfo':
      case 'chro':
      case 'cmo':
      case 'coo':
      case 'cso':
      case 'cto':
        return 'computer';
      case 'developer':
        return 'computer';
      case 'product-designer':
        return 'brush';
      case 'product-manager':
        return 'computer';
      case 'tech-lead':
        return 'computer';
      default:
        return 'no_accounts';
    }
  }
}
